import { useState } from 'react'
// Components

import WelcomeCard from '../../components/cards/WelcomeCard/WelcomeCard';
import RegisterForm from '../../components/forms/RegisterForm/RegisterForm';
import AccessCodeForm from '../../components/forms/AccessCodeForm/AccessCodeForm';
// import LogInForm from '../../components/forms/LogInForm/LogInForm';

// Styles

import './Styles.scss';

export default function UserAccess() {
  const [showForm, setShowForm] = useState('register');
  const [userName, setUsername] = useState();
  const [userEmail, setUserEmail] = useState();
  const [userPhone, setUserPhone] = useState();

  return (
    <div className="page-wrapper">
      <div className="container">
        <div className='user-access'>
          <WelcomeCard />

          <div className='user-access-forms'>

            {showForm === 'register' &&
              <RegisterForm setShowForm={setShowForm} setUsername={setUsername} setUserEmail={setUserEmail} setUserPhone={setUserPhone} />}

            {/* {showForm === 'login' &&
            <LogInForm setShowForm={setShowForm} />} */}

            {showForm === 'code' &&
              <AccessCodeForm setShowForm={setShowForm} userName={userName} userEmail={userEmail} userPhone={userPhone} />}

          </div>
        </div>
      </div>
    </div>
  )
}
